
// document.addEventListener('click', function (event) {
//   if (event.target.closest('.snippet-product-grid .quick-add')) {
//     const btn = event.target.closest('.quick-add');
//     const productGrid = btn.closest('.snippet-product-grid');
//     if (!productGrid) return;
//     const mainQuickShop = productGrid.querySelector('.main-quick-shop');
//     if (mainQuickShop) {
//       productGrid.dataset.originalQuickShop = 'true';
//       document.querySelector('.fixed-quick').appendChild(mainQuickShop);
//       document.body.classList.add('open-quick-view');
//       new Swiper(".fixed-quick .top-img-slider.swiper", {
//         slidesPerView: "auto",
//         navigation: {
//           nextEl: ".fixed-quick .swiper-button-next",
//           prevEl: ".fixed-quick .swiper-button-prev",
//         },
//       });
//     }
//   }
//   if (event.target.closest('.fixed-quick .select-size')) {
//     const selector = event.target.closest('.select-size');
//     selector.classList.toggle('active');
//     document.body.classList.toggle('open-quick-var');
//   }
//   if (event.target.closest('.fixed-quick .upsell-var .var')) {
//     const varBtn = event.target.closest('.var');
//     const text = varBtn.textContent;
//     const id = varBtn.getAttribute('data-id');

//     const textElement = document.querySelector('.fixed-quick .quick-var .select-size .text');
//     const addToCartBtn = document.querySelector('.fixed-quick .quick-add-to-cart');

//     if (textElement && addToCartBtn) {
//       textElement.textContent = text;
//       addToCartBtn.setAttribute('data-id', id);
//     }

//     document.body.classList.remove('open-quick-var');
//     const selector = document.querySelector('.fixed-quick .select-size');
//     if (selector) selector.classList.remove('active');
//   }
//   if (event.target.closest('.fixed-quick .quick-add-to-cart')) {
//     const addToCartBtn = event.target.closest('.quick-add-to-cart');
//     const line = addToCartBtn.getAttribute('data-id');
//     if (!line) return;

//     const data = {
//       items: [{
//         id: line,
//         quantity: 1
//       }]
//     };

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(data),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         document.body.classList.remove('open-quick-view');
//         document.body.classList.add('open-drawer');

//         const closeBtn = document.querySelector('.fixed-quick .quick-close');
//         if (closeBtn) closeBtn.click();

//         load_cart(); // Ensure this function is defined globally
//       })
//       .catch((error) => {
//         console.error('Error:', error);
//       });
//   }
//   if (event.target.closest('.quick-close')) {
//     document.body.classList.remove('open-quick-view');
  
//     const fixedQuick = document.querySelector('.fixed-quick');
//     const mainQuickShop = fixedQuick?.querySelector('.main-quick-shop');
//     const originalContainer = document.querySelector('.snippet-product-grid[data-original-quick-shop="true"]');
  
//     if (mainQuickShop && originalContainer) {
//       try {
        
//         if (mainQuickShop.parentNode === fixedQuick) {
//           fixedQuick.removeChild(mainQuickShop);
//         }
  
//         originalContainer.appendChild(mainQuickShop);
//         originalContainer.removeAttribute('data-original-quick-shop');
//       } catch (e) {
//         console.warn('safe removeChild failed:', e);
//       }
//     }
//   }
// });

// // Quick-view js

// document.querySelectorAll('.sin-color').forEach(item => {
//   item.addEventListener('click', function () {
//     const handle = this.getAttribute('data-handle');
//     if (!handle) return;

//     fetch(`/products/${handle}?section_id=quick-buy`)
//       .then(response => {
//         if (!response.ok) throw new Error('Network response was not ok');
//         return response.text();
//       })
//       .then(html => {
//         const fixedQuick = document.querySelector('.fixed-quick');
//         if (!fixedQuick) return;

        
//         const tempDiv = document.createElement('div');
//         tempDiv.innerHTML = html;
//         const mainQuickShop = tempDiv.querySelector('.main-quick-shop');

//         if (mainQuickShop) {
//           fixedQuick.innerHTML = ''; 
//           fixedQuick.appendChild(mainQuickShop); 

//           document.body.classList.add('open-quick-view');

          
//           new Swiper(".fixed-quick .top-img-slider.swiper", {
//             slidesPerView: "auto",
//             navigation: {
//               nextEl: ".fixed-quick .swiper-button-next",
//               prevEl: ".fixed-quick .swiper-button-prev",
//             },
//           });
//         }
//       })
//       .catch(error => {
//         console.error('Error fetching quick buy section:', error);
//       });
//   });
// });



document.addEventListener('click', function (event) {
if (event.target.closest('.snippet-product-grid .quick-add')) {

    const btn = event.target.closest('.quick-add');
    const productGrid = btn.closest('.snippet-product-grid');
    if (!productGrid) return;

    const mainQuickShop = productGrid.querySelector('.main-quick-shop');
    if (mainQuickShop) {
      productGrid.dataset.originalQuickShop = 'true';

      const quickShopClone = mainQuickShop.cloneNode(true);
      const fixedQuick = document.querySelector('.fixed-quick');

      fixedQuick.innerHTML = ''; 
      fixedQuick.appendChild(quickShopClone);

      document.body.classList.add('open-quick-view');

      new Swiper(".fixed-quick .top-img-slider.swiper", {
        slidesPerView: "auto",
        freeMode: true,
        // spaceBetween: 10,
        navigation: {
          nextEl: ".fixed-quick .swiper-button-next",
          prevEl: ".fixed-quick .swiper-button-prev",
        },
      });
    }
  }
  function toggleScrollClass() {
    const selectors = [
      '.fixed-quick .main-quick-shop .inner-qs',
      '.fixed-quick .main-quick-shop'
    ];

    selectors.forEach(sel => {
      const el = document.querySelector(sel);
      if (!el) return;

      if (el.scrollHeight > el.clientHeight) {
        el.classList.add('show-scroll');
      } else {
        el.classList.remove('show-scroll');
      }
    });
  }



  toggleScrollClass();

  window.addEventListener('resize', toggleScrollClass);
  
  if (event.target.closest('.fixed-quick .select-size')) {
    const selector = event.target.closest('.select-size');
    selector.classList.toggle('active');
    document.body.classList.toggle('open-quick-var');
  }
  if (event.target.closest('.fixed-quick .dummy-add-btn')) {
    const selector = event.target.closest('.dummy-add-btn');
    selector.classList.add('active-hover');
    selector.textContent = 'please select phone size';
  }
  if (event.target.closest('.fixed-quick .upsell-var .var')) {
    const varBtn = event.target.closest('.var');
    const text = varBtn.textContent;
    const id = varBtn.getAttribute('data-id');
    const textElement = document.querySelector('.fixed-quick .quick-var .select-size .text');
    const addToCartBtn = document.querySelector('.fixed-quick .quick-add-to-cart');

    if (textElement && addToCartBtn) {
      textElement.textContent = text;
      addToCartBtn.setAttribute('data-id', id);
    }

    document.body.classList.remove('open-quick-var');
    const selector = document.querySelector('.fixed-quick .select-size');
    document.querySelectorAll('.quick-var').forEach(function(el) {
      el.classList.add('size-selected');
    });
    if (selector) selector.classList.remove('active');
  }
  if (event.target.closest('.fixed-quick .quick-add-to-cart')) {
    const addToCartBtn = event.target.closest('.quick-add-to-cart');
    const line = addToCartBtn.getAttribute('data-id');
    if (!line) return;

    const data = {
      items: [{
        id: line,
        quantity: 1
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        document.body.classList.remove('open-quick-view');
        document.body.classList.add('open-drawer');

        const closeBtn = document.querySelector('.fixed-quick .quick-close');
        if (closeBtn) closeBtn.click();

        load_cart(); // Ensure this function is defined globally
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
  if (event.target.closest('.quick-close')) {
    document.body.classList.remove('open-quick-view');
    document.querySelectorAll('.quick-var.multiple-var').forEach(function(el) {
      el.classList.remove('size-selected');
    });
    const fixedQuick = document.querySelector('.fixed-quick');
    fixedQuick.innerHTML = ' ';

  }
  document.querySelectorAll('.fixed-quick .sin-color').forEach(item => {
    item.addEventListener('click', function () {
      const handle = this.getAttribute('data-handle');
      if (!handle) return;
  
      fetch(`/products/${handle}?section_id=quick-buy`)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(html => {
          const fixedQuick = document.querySelector('.fixed-quick');
          if (!fixedQuick) return;
  
          
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const mainQuickShop = tempDiv.querySelector('.main-quick-shop');
  
          if (mainQuickShop) {
            fixedQuick.innerHTML = ''; 
            fixedQuick.appendChild(mainQuickShop); 
  
            document.body.classList.add('open-quick-view');
  
            
            new Swiper(".fixed-quick .top-img-slider.swiper", {
              slidesPerView: "auto",
              freeMode: true,
              navigation: {
                nextEl: ".fixed-quick .swiper-button-next",
                prevEl: ".fixed-quick .swiper-button-prev",
              },
            });
          }
        })
        .catch(error => {
          console.error('Error fetching quick buy section:', error);
        });
    });
  });
});

// Quick-view js



document.querySelectorAll(".snippet-product-grid").forEach(function (card) {
  const imgs = card.querySelectorAll(".product-images img"); 
  if (imgs.length === 0) return;

  const firstImg = imgs[0];               
  const secondImg = imgs[1] || null;      
  const swatches = card.querySelectorAll(".grid-color .sin-color");

  if (!swatches.length) return;

  const firstSwatch = swatches[0];
  const defaultImg1 = firstSwatch.getAttribute("data-image");
  const defaultImg2 = firstSwatch.getAttribute("data-image-2");


  swatches.forEach(s => s.classList.remove("active"));
  firstSwatch.classList.add("active");
  if (defaultImg1) {
    firstImg.setAttribute("src", defaultImg1);
    firstImg.setAttribute("srcset", defaultImg1);
  }
  if (defaultImg2 && secondImg) {
    secondImg.setAttribute("src", defaultImg2);
    secondImg.setAttribute("srcset", defaultImg2);
  }

  swatches.forEach(function (swatch) {
    swatch.addEventListener("mouseenter", function () {
      swatches.forEach(s => s.classList.remove("active"));
      swatch.classList.add("active");

      const newImg1 = swatch.getAttribute("data-image");
      const newImg2 = swatch.getAttribute("data-image-2");

      if (newImg1) {
        firstImg.setAttribute("src", newImg1);
        firstImg.setAttribute("srcset", newImg1);
      }
      if (newImg2 && secondImg) {
        secondImg.setAttribute("src", newImg2);
        secondImg.setAttribute("srcset", newImg2);
      }
    });
  });


  const gridColor = card.querySelector(".grid-color");
  if (gridColor) {
    gridColor.addEventListener("mouseleave", function () {
      swatches.forEach(s => s.classList.remove("active"));
      firstSwatch.classList.add("active");

      if (defaultImg1) {
        firstImg.setAttribute("src", defaultImg1);
        firstImg.setAttribute("srcset", defaultImg1);
      }
      if (defaultImg2 && secondImg) {
        secondImg.setAttribute("src", defaultImg2);
        secondImg.setAttribute("srcset", defaultImg2);
      }
    });
  }
});
